import { PersistedExternalDocument } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const deleteExternalDocument = actionCreator<PersistedExternalDocument>(
  '[External Document] DELETE_EXTERNAL_DOCUMENT'
);

export const openExternalDocument = actionCreator<PersistedExternalDocument>(
  '[External Document] OPEN_EXTERNAL_DOCUMENT'
);

export const lucidClientIdLoaded = actionCreator<string>(
  '[External Document] LUCID_CLIENT_ID_LOADED'
);
